var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTakeAway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.05675 4.30771C5.05667 4.30357 5.05663 4.29942 5.05663 4.29526V3.45886C5.05663 1.72663 6.46088 0.322388 8.19312 0.322388C9.92538 0.322388 11.3296 1.72663 11.3296 3.45886V4.29526C11.3296 4.29942 11.3295 4.30357 11.3294 4.30771C12.4061 4.34003 13.0649 4.45618 13.5679 4.8736C14.2648 5.45195 14.4483 6.4309 14.8154 8.38882L15.4427 11.7344C15.959 14.4876 16.217 15.8641 15.4645 16.7708C14.712 17.6776 13.3114 17.6776 10.5103 17.6776H5.87593C3.07479 17.6776 1.67423 17.6776 0.921714 16.7708C0.169194 15.8641 0.427305 14.4876 0.943519 11.7344L1.57081 8.38882C1.93792 6.4309 2.12147 5.45195 2.81834 4.8736C3.3213 4.45618 3.9801 4.34003 5.05675 4.30771ZM6.31122 3.45886C6.31122 2.41953 7.15374 1.57698 8.19312 1.57698C9.23242 1.57698 10.075 2.41953 10.075 3.45886V4.29526C10.075 4.29525 10.075 4.29527 10.075 4.29526C10.012 4.29524 9.94804 4.29526 9.88297 4.29526H6.50322C6.43817 4.29526 6.37417 4.29526 6.31122 4.29528V3.45886Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakeAway);
export default __webpack_public_path__ + "static/media/takeAway.594f6c277582bb387bed3651c8a73a9a.svg";
export { ForwardRef as ReactComponent };